import { http } from './http';

export type StatusReasonDTO = {
  title: string;
  secondary_status_reasons: { title: string }[];
};

export const fetchStatusReason = async () => {
  const { data } = await http.get<StatusReasonDTO[]>('/status_reasons');

  return data;
};
